// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #333;
    color: white;
    text-align: center;
    padding: 20px;
}

.footer-images {
    display: flex;
    justify-content: center;
    align-items: flex-start; /* Align to top */
    gap: 20px; /* Space between the logos */
    margin-bottom: 10px;
    flex-wrap: wrap;
}

.footer-logo-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px; /* Much closer gap - reduced from 2px */
    justify-content: flex-start;
    padding-top: 0; /* No top padding */
    margin-top: -5px; /* Move up slightly */
}

.footer-logo {
    max-width: 180px; /* Slightly smaller to align with text */
    max-height: 55px; /* Slightly smaller height */
    height: auto;
    width: auto;
    object-fit: contain;
}

.footer-logo-text {
    font-size: 0.6rem;
    color: #ccc;
    margin: 0;
    font-style: italic;
    text-align: center;
    max-width: 180px; /* Match logo width */
    line-height: 1.2;
    white-space: nowrap; /* Prevent line breaks */
    overflow: visible; /* Allow text to be visible */
}

/* C2SMART logo - slightly smaller */
.footer-logo[alt="C2SMART logo"] {
    max-width: 130px;
    max-height: 50px;
}

/* CMU logo - bigger */
.cmu-footer-logo {
    max-width: 280px; /* Even bigger */
    max-height: 110px; /* Even bigger height */
    height: auto;
    width: auto;
    object-fit: contain;
}

footer p {
    margin: 0;
    padding: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB,EAAE,iBAAiB;IAC1C,SAAS,EAAE,4BAA4B;IACvC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ,EAAE,uCAAuC;IACjD,2BAA2B;IAC3B,cAAc,EAAE,mBAAmB;IACnC,gBAAgB,EAAE,qBAAqB;AAC3C;;AAEA;IACI,gBAAgB,EAAE,wCAAwC;IAC1D,gBAAgB,EAAE,4BAA4B;IAC9C,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB,EAAE,qBAAqB;IACvC,gBAAgB;IAChB,mBAAmB,EAAE,wBAAwB;IAC7C,iBAAiB,EAAE,6BAA6B;AACpD;;AAEA,oCAAoC;AACpC;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,gBAAgB,EAAE,gBAAgB;IAClC,iBAAiB,EAAE,uBAAuB;IAC1C,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,aAAa;AACjB","sourcesContent":[".footer {\n    background-color: #333;\n    color: white;\n    text-align: center;\n    padding: 20px;\n}\n\n.footer-images {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start; /* Align to top */\n    gap: 20px; /* Space between the logos */\n    margin-bottom: 10px;\n    flex-wrap: wrap;\n}\n\n.footer-logo-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1px; /* Much closer gap - reduced from 2px */\n    justify-content: flex-start;\n    padding-top: 0; /* No top padding */\n    margin-top: -5px; /* Move up slightly */\n}\n\n.footer-logo {\n    max-width: 180px; /* Slightly smaller to align with text */\n    max-height: 55px; /* Slightly smaller height */\n    height: auto;\n    width: auto;\n    object-fit: contain;\n}\n\n.footer-logo-text {\n    font-size: 0.6rem;\n    color: #ccc;\n    margin: 0;\n    font-style: italic;\n    text-align: center;\n    max-width: 180px; /* Match logo width */\n    line-height: 1.2;\n    white-space: nowrap; /* Prevent line breaks */\n    overflow: visible; /* Allow text to be visible */\n}\n\n/* C2SMART logo - slightly smaller */\n.footer-logo[alt=\"C2SMART logo\"] {\n    max-width: 130px;\n    max-height: 50px;\n}\n\n/* CMU logo - bigger */\n.cmu-footer-logo {\n    max-width: 280px; /* Even bigger */\n    max-height: 110px; /* Even bigger height */\n    height: auto;\n    width: auto;\n    object-fit: contain;\n}\n\nfooter p {\n    margin: 0;\n    padding: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
